import { Component, HostBinding, OnDestroy, OnInit } from "@angular/core";
import { WindowService } from "@merri/common";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { HELP_EMAIL } from "src/app/core";
import { LayoutService } from "src/app/layout";

@Component({
    selector: "app-public-header",
    templateUrl: "./public-header.component.html",
    styleUrls: ["./public-header.component.scss"],
    standalone: false
})
export class PublicHeaderComponent implements OnInit, OnDestroy {
  private destroyed$: Subject<void> = new Subject<void>();

  mobileView: boolean;
  showLearnMore: boolean;
  showMobileMenu: boolean;

  @HostBinding("style.display") hostDisplay: string;

  readonly HELP_EMAIL = HELP_EMAIL;

  constructor(private windowService: WindowService, private _layoutService: LayoutService) {}

  ngOnInit() {
    this.windowService
      .observeMax$(550)
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: result => {
          this.mobileView = result.matches;
        },
      });

    this._layoutService.layoutChange$.pipe(takeUntil(this.destroyed$)).subscribe({
      next: result => {
        this.showLearnMore = !result.hideLearnMore;
        this.showMobileMenu = !result.hideMobileMenu;

        this.hostDisplay = !this.showLearnMore && !this.showMobileMenu ? "none" : "block";
      },
    });
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
